import { BadgeProps } from '@mui/material';

import { HBIcon, HBIconType } from '../HBIcon/HBIcon';
import { HBBadgeRootStyle } from './HBBadge.styles';

export interface HBBadgeProps extends Omit<BadgeProps, 'ref' | 'childern'> {
  children?: HBIconType | JSX.Element;
}

export const HBBadge = ({ children, ...props }: HBBadgeProps): JSX.Element => {
  return (
    <HBBadgeRootStyle {...props}>
      {typeof children === 'string' ? <HBIcon type={children} size="medium" /> : children}
    </HBBadgeRootStyle>
  );
};
